import NestedSet from 'nested-set';

export const getMainTaxonList = (taxon) => {
  if (taxon.parent && taxon.parent.level > 0) {
    return [...getMainTaxonList(taxon.parent), taxon];
  }

  return [taxon];
};

export const isMainTaxon = (taxon) => taxon.level === 1;
export const isLeafTaxon = (taxon) => taxon.right - taxon.left === 1;
export const findMenuTaxon = (taxon) =>
  isMainTaxon(taxon) ? taxon : taxon.parents.find(isMainTaxon);
export const findProductMenuTaxon = (product) => {
  return getMainTaxonList(product.mainTaxon).find(isMainTaxon);
}

export const taxonNestedSet = NestedSet({ left: 'left', right: 'right' });

export const getBlockedTaxonsList = (options) => {
  if (!process.env.EXCLUDED_TAXONS || Object.keys(process.env.EXCLUDED_TAXONS).length === 0) {
    return null;
  }

  const { country, ip } = options;

  const data = JSON.parse(process.env.EXCLUDED_TAXONS);
  const excludedTaxons = Object.keys(data);

  const blockedList = excludedTaxons
    .map((taxon) => {
      if (Array.isArray(data[taxon].countries) && data[taxon].countries.length > 0) {
        if (data[taxon].countries.includes(country)) {
          return taxon;
        }
      }

      if (Array.isArray(data[taxon].addresses) && data[taxon].addresses.length > 0) {
        if (data[taxon].addresses.includes(ip)) {
          return taxon;
        }
      }
    })
    .filter((item) => typeof item === 'string');

  if (blockedList.length > 0) {
    return blockedList;
  } else {
    return null;
  }
};



// WEBPACK FOOTER //
// ./utils/taxons.js